import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import _ from "lodash";
import { VendorItem } from "./VendorItem";

export default function ListVendor({
  data_vendor,
  booking_details,
  vendor_details,
  data_mail,
  ConfirmClick,
  DeleteClick,
  EditOperClick,
}) {
  let data_clean = _(vendor_details)
    .sortBy(["vendor_type", "day_index"])
    .groupBy((x) => x.vendor_id)
    .map((value, key) => ({
      vendor_id: key,
      vendor_code: value[0].vendor_code,
      vendor_type: value[0].vendor_type,
      booking_id: value[0].booking_id,
      mail_sent: _.find(data_mail, { vendor_id: key }),
      data: value,
      data_vendor: _.find(data_vendor, ["_id", key]),
    }))
    .value();

  return (
    <Box style={{ marginTop: 16, marginBottom: 10 }}>
      {data_clean.map((item, index) => (
        <VendorItem
          item={item}
          index={index}
          booking_details={booking_details}
          vendor_details={vendor_details}
          DeleteClick={DeleteClick}
          ConfirmClick={ConfirmClick}
          EditOperClick={EditOperClick}
        />
      ))}
    </Box>
  );
}
